import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { Container, TextField, Button } from '@material-ui/core';
import consts from './main/consts';
import { Redirect } from 'react-router-dom';
import { doLogin } from './state/auth/authActions';
import { grey } from '@material-ui/core/colors';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: grey[200],
    height: '100vh'
  },
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  input: {
    marginBottom: theme.spacing(1)
  }
});
class LoginForm extends React.Component {

  state = {
    API_URL: consts.API_URL,
    MAESTRO_FRONTEND_URL: window.location.origin,
    AZURE_ENTRY_POINT: `${consts.AZURE_ENTRY_POINT}`,
    NOTIFICATIONS_SERVICE: consts.NOTIFICATIONS_SERVICE,
    STORES_ENDPOINT: consts.STORES_ENDPOINT,
    AZURE_USER_EMAIL: consts.DEBUG_USER_EMAIL,
    AZURE_USER_NOME: consts.DEBUG_USER_NAME,
    DEBUG_LOJA: consts.DEBUG_LOJA,
  }

  componentDidMount() {
    this.setState(this.state);
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    let params = { ...this.state };

    console.log('params', params);

    let queryString = Object.keys(params).map(function (k) {
      return k + '=' + encodeURIComponent(params[k]);
    }).join('&');

    const url = `${window.location.origin}/?debug=true&${queryString}`;

    window.location.href = url;
  }

  handlePortForward = (event) => {
    event.preventDefault();
    let setValues = {
      API_URL: 'http://localhost:3001/v2/backend',
      AZURE_ENTRY_POINT: 'https://localhost:3001/avoidAzure',
      NOTIFICATIONS_SERVICE: 'http://localhost:3002',
    }
    this.setState({ ...this.state, ...setValues });
  }

  render() {

    const { classes } = this.props;

    if (!consts.ENABLE_LOGIN) return (<Redirect to="/" />)

    return (
      <div className={classes.root}>

        <Container component="main" maxWidth="xs" >
          <CssBaseline />
          <div className={classes.paper}>
            <Button
              type="buttom"
              fullWidth
              variant="outlined"
              color="secondary"
              className={classes.submit}
              onClick={this.handlePortForward}>
              PORT FORWARD
          </Button>
            <form className={classes.form} onSubmit={this.handleSubmit}>
              <TextField
                variant="outlined"
                fullWidth
                label="FRONTEND URL"
                name="MAESTRO_FRONTEND_URL"
                id="MAESTRO_FRONTEND_URL"
                margin="dense"
                value={this.state.MAESTRO_FRONTEND_URL}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />
              <TextField
                variant="outlined"
                fullWidth
                label="BACKEND URL"
                name="API_URL"
                id="API_URL"
                margin="dense"
                value={this.state.API_URL}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />
              <TextField
                variant="outlined"
                fullWidth
                label="AZURE ENTRY POINT"
                name="AZURE_ENTRY_POINT"
                id="AZURE_ENTRY_POINT"
                margin="dense"
                value={this.state.AZURE_ENTRY_POINT}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />
              <TextField
                variant="outlined"
                fullWidth
                label="NOTIFICATIONS SERVICE"
                name="NOTIFICATIONS_SERVICE"
                id="NOTIFICATIONS_SERVICE"
                margin="dense"
                value={this.state.NOTIFICATIONS_SERVICE}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />
              <TextField
                variant="outlined"
                fullWidth
                label="STORES ENDPOINT"
                name="STORES_ENDPOINT"
                id="STORES_ENDPOINT"
                margin="dense"
                value={this.state.STORES_ENDPOINT}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />
              <TextField
                variant="outlined"
                fullWidth
                label="AZURE_USER_EMAIL"
                name="AZURE_USER_EMAIL"
                id="AZURE_USER_EMAIL"
                margin="dense"
                value={this.state.AZURE_USER_EMAIL}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />
              <TextField
                variant="outlined"
                fullWidth
                label="AZURE_USER_NOME"
                name="AZURE_USER_NOME"
                id="AZURE_USER_NOME"
                margin="dense"
                value={this.state.AZURE_USER_NOME}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />
              <TextField
                variant="outlined"
                fullWidth
                label="DEBUG_LOJA"
                name="DEBUG_LOJA"
                id="DEBUG_LOJA"
                margin="dense"
                value={this.state.DEBUG_LOJA}
                onChange={(e) => {
                  this.handleChange(e.target.name, e.target.value)
                }}
                className={classes.input}
              />


              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}>
                LOGIN
            </Button>

            </form>
          </div>
        </Container>
      </div>
    );
  }
}



const mapStateToProps = (state) => {
  return { auth: state.auth };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ doLogin }, dispatch);
export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LoginForm);